export default __webpack_public_path__ + "static/media/drb.80f84d14.svg";